import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import WordController from './WordController';

export default class TentancleGrabber extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {{x:number, y:number}} pos 
   * @param {Phaser.GameObjects.Text} letter
   * @param {WordController} wordController
   */
  constructor(scene, pos, letter, wordController) {
    super(scene);

    this.wordController = wordController;

    this.pos = pos;
    this.letter = letter;

    this.tentacle = null;

    this.tentTween = null;
    this.scaleTween = null;

    this.setup();
  }

  setup () {
    this.createTentacle();
    this.ascend();
  }

  createTentacle () {
    let nameInit = UIAssetKeys._8_Octopus_Tentacles_Tentacle00;
    let nameStart = '8_Octopus Tentacles/Tentacle';
    if (gameData.config.level === 4) {
      nameInit = UIAssetKeys._8_Octopus_Tentacles_Tentacle_Glow00;
      nameStart = '8_Octopus Tentacles/Tentacle_Glow';
    }

    this.tentacle = this.scene.add.sprite(0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, nameInit).setOrigin(0.5, 0);
    this.add(this.tentacle);

    this.tentacle.anims.create({
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      key: 'grab',
      frameRate: 60,
      frames: this.scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
        prefix: nameStart,
        start: 0,
        end: 19,
        zeroPad: 2
      })
    });

    this.tentacle.on(Phaser.Animations.Events.ANIMATION_COMPLETE, this.descend, this);

    this.setPosition(this.pos.x + 40, this.scene.scale.height);
  }

  playAnim () {
    this.tentacle.play('grab', true);
  }

  ascend () {
    this.scene.time.delayedCall(250, this.playAnim, null, this);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._octopus_tenticles, this.scene);

    let newY = 220;
    let newScale = 1;
    if (this.pos.y <= 150) {
      newY = 340;
      newScale = 1.5;
    }
    else if (this.pos.y > 150 && this.pos.y < 250) {
      newY = 290;
      newScale = 1.2;
    }

    this.scaleTween = ABCyaPhaser.Tweens.addTween(this, 500, { scaleY: newScale }, Phaser.Math.Easing.Linear);
    this.tentTween = ABCyaPhaser.Tweens.addTween(this, 500, { y: this.pos.y - newY }, Phaser.Math.Easing.Linear);
  }

  descend () {
    // get the position of the letter within the tentacle grabber container
    const letterLocalPos = this.getLocalPoint(this.letter.x, this.letter.y);
    this.addAt(this.letter, 0);

    const newScale = 1 / this.scaleY;

    this.letter.setPosition(letterLocalPos.x, letterLocalPos.y);
    this.letter.scaleY = newScale;

    this.tentTween = ABCyaPhaser.Tweens.addTween(this, 600, { y: this.scene.scale.height }, Phaser.Math.Easing.Linear, () => {
      this.cleanUp();
    });
  }

  cleanUp () {
    if (!this.wordController.initUpdate) this.wordController.updateScore(this.letter);

    this.scene.tweens.killTweensOf(this);
    this.tentTween.stop();
    this.scaleTween.stop();
    this.tentacle.stop();

    this.tentacle.destroy();
  }
}